/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    searchInventory(params) {
        return HttpService.get(environment.API_SEARCH_INVENTORY, {
            params,
        });
    },

    getBusinessProcess(departmentId) {
        return HttpService.get(
            environment.API_BUSINESS_PROCESS + '/' + departmentId
        );
    },

    getDepartmentList() {
        return HttpService.get(environment.API_DEPARTMENT_SEARCH + '/all');
    },

    getDataOwner(departmentId) {
        return HttpService.get(environment.API_DATA_OWNER + '/' + departmentId);
    },

    getReviewBy(ownerId) {
        return HttpService.get(environment.API_REVIEW_BY + '/' + ownerId);
    },

    createBusinessProcess(payload) {
        return HttpService.post(
            environment.API_CREATE_BUSINESS_PROCESS,
            payload
        );
    },

    addInventory(payload) {
        return HttpService.post(environment.API_ADD_INVENTORY, payload);
    },

    addActivityName(payload) {
        return HttpService.post(environment.API_ADD_ACTIVITY_NAME, payload);
    },

    editActivityName(payload) {
        return HttpService.put(environment.API_EDIT_ACTIVITY_NAME, payload);
    },

    changeStatus(payload) {
        return HttpService.put(
            environment.API_EDIT_ACTIVITY_NAME + '/status',
            payload
        );
    },

    deleteActivityName(id) {
        return HttpService.delete(environment.API_ADD_ACTIVITY + '/' + id);
    },

    // Data Inventory Detail

    getActivityDetail(id) {
        return HttpService.get(environment.API_ADD_ACTIVITY + '/tab/' + id);
    },

    getActivity(id) {
        return HttpService.get(environment.API_ADD_ACTIVITY + '/' + id);
    },

    getActivityTab() {
        return HttpService.get(environment.API_ADD_ACTIVITY + '/m/tab');
    },

    getDataSubjectRight() {
        return HttpService.get(environment.API_DATA_SUBJECT_RIGHT);
    },

    getDataCategory() {
        return HttpService.get(environment.API_DATA_CATEGORY);
    },

    getDataRisk() {
        return HttpService.get(environment.API_DATA_RISK);
    },

    getDataSecret() {
        return HttpService.get(environment.API_DATA_SECRET);
    },

    getDataDocumentType() {
        return HttpService.get(environment.API_DATA_DOCUMENT_TYPE);
    },

    createActivity(payload) {
        return HttpService.post(environment.API_ADD_ACTIVITY + '/tab', payload);
    },

    createDataflow(payload) {
        return HttpService.post(environment.API_DATA_FLOW, payload);
    },

    editDataflow(payload) {
        return HttpService.put(environment.API_DATA_FLOW, payload);
    },
    getDropdownLawful() {
        return HttpService.get(environment.API_LAWFUL_BASIS + '/dropdown');
    },
    updateLawfulBasis(payload) {
        return HttpService.put(
            environment.API_ADD_ACTIVITY + '/lawful',
            payload
        );
    },
    getCompanyList() {
        return HttpService.get(
            environment.API_WFSECURE + '/company/domainlist'
        );
    },
};
